// src/firebase.js
// Configuration Firebase pour VOMM FJKM Hannover
// Version sécurisée avec variables d'environnement

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { logger, performance, logFirebaseError } from './utils/logger';


// Configuration Firebase depuis variables d'environnement
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Validation des variables d'environnement
const validateConfig = () => {
  const required = [
    'REACT_APP_FIREBASE_API_KEY',
    'REACT_APP_FIREBASE_AUTH_DOMAIN',
    'REACT_APP_FIREBASE_PROJECT_ID',
    'REACT_APP_FIREBASE_STORAGE_BUCKET',
    'REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
    'REACT_APP_FIREBASE_APP_ID'
  ];

  const missing = required.filter(key => !process.env[key]);

  if (missing.length > 0) {
    logger.error('❌ Variables d\'environnement Firebase manquantes:');
    missing.forEach(key => logger.error(`   - ${key}`));
    logger.error('\n💡 Solution:');
    logger.error('   1. Vérifier que le fichier .env existe à la racine');
    logger.error('   2. Redémarrer: npm start\n');
    throw new Error('Configuration Firebase incomplète');
  }
};

// Valider la configuration
validateConfig();

// Initialiser Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

// Connecter à l'émulateur en développement si configuré
if (process.env.REACT_APP_USE_FIREBASE_EMULATOR === 'true') {
  connectFunctionsEmulator(functions, 'localhost', 5001);
  logger.log('🔧 Functions Emulator connecté');
}

// Log en développement
if (process.env.NODE_ENV === 'development') {
  logger.log('✅ Firebase initialisé avec succès');
  logger.log('📦 Projet:', firebaseConfig.projectId);
}

export default app;
